import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICustomField, IObjectCustomFields } from 'src/app/features/settings/models/settings.models';
import { CustomFieldTypes } from 'src/app/features/settings/models/custom-fields.constants';
import { CustomFieldDisplayService, ICustomFieldValues } from 'src/app/shared/custom-field-display.service';

@Component({
  selector: 'app-object-custom-fields-view',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './object-custom-fields-view.component.html',
  styleUrls: ['./object-custom-fields-view.component.scss'],
})
export class ObjectCustomFieldsViewComponent {
  @Input() objectCustomFields: IObjectCustomFields | null = null;
  @Input() currentLanguage: string = 'en';
  @Input() emptyValuePlaceholder: string = CustomFieldDisplayService.EMPTY_PLACEHOLDER;
  readonly customFieldTypes = CustomFieldTypes;

  constructor(private display: CustomFieldDisplayService) { }

  private get values(): ICustomFieldValues | null {
    return (this.objectCustomFields?.values as ICustomFieldValues) ?? null;
  }

  getLabel(def: ICustomField): string {
    return this.display.label(def, this.currentLanguage);
  }

  hasValue(def: ICustomField): boolean {
    return this.display.hasValue(this.values, def);
  }

  getValue(def: ICustomField): any {
    return this.display.value(this.values, def);
  }

  getSelectValues(def: ICustomField): string[] {
    return this.display.selectValues(this.values, def);
  }

  isEmail(def: ICustomField): boolean {
    return this.display.isEmail(def);
  }

  isUrl(def: ICustomField): boolean {
    return this.display.isUrl(def);
  }

  getTextValue(def: ICustomField): string {
    return this.display.text(this.values, def, this.emptyValuePlaceholder);
  }

  getHref(def: ICustomField): string {
    return this.display.href(this.values, def);
  }
}
